import helper from '../helper'

export default {
  controller: '/auth',
  login (username, password, callback) {
    helper.postRequest(this.controller + '/login', false, { username, password }, callback)
  },
  refresh (callback) {
    helper.postRequest(this.controller + '/refresh', true, null, callback)
  }
}



// WEBPACK FOOTER //
// ./src/services/rest/controllers/auth.js